export default __webpack_public_path__ + "static/media/speedup.d71ead93.mp3";